import { render } from "./ArticleHistory.vue?vue&type=template&id=c1cb5d4a&scoped=true"
import script from "./ArticleHistory.vue?vue&type=script&lang=js"
export * from "./ArticleHistory.vue?vue&type=script&lang=js"

import "./ArticleHistory.vue?vue&type=style&index=0&id=c1cb5d4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1cb5d4a"]])

export default __exports__